/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_MY_PROFILE = gql`
query GetMyProfile {
  getMyProfile {
    email
    givenName
    familyName
    fullName
    emailVerified
    isRegistered
    isInviEmailSent
    role {
      name
      _id
      permissions {
        subject
        action
        inverted
        fields
      }
    }
    brand {
      _id
      sameAs
      telephone
      description
      name
      email
      creator
      address {
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
      }
      fullAddress
      logo
      createdAt
      updatedAt
      OrgType
      type
      walletAddress
      chainId
      isWalletRegistered
      supportedChainId
    }
  }
}
`